export enum AlertClassEnum {
  AlertInfo = 'alert-info',
  AlertWarning = 'alert-warning',
  AlertSuccess = 'alert-success',
  AlertDanger = 'alert-danger'
}
